import React, { useContext } from "react";
import DomainContext from "../../context/DomainContext";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import { getSEO } from "../../utils/utils";

export default ({ page }) => {
  const domain = useContext(DomainContext);
  return <GatsbySeo {...getSEO(page, domain)} />;
};
